import script from "./Agency_Index.vue?vue&type=script&setup=true&lang=js"
export * from "./Agency_Index.vue?vue&type=script&setup=true&lang=js"

import "./Agency_Index.vue?vue&type=style&index=0&id=4c151ab4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c151ab4"]])

export default __exports__